import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpListValueElementFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { ExpAdditionalDataFactory } from "./ExpAdditionalData";

/**
 * 
 * @export
 * @interface ExpListValueElement
 */

export class ExpListValueElementFactory {}
_ExpListValueElementFactory = ExpListValueElementFactory;
_defineProperty(ExpListValueElementFactory, "FromJSON", function (json) {
  return _ExpListValueElementFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpListValueElementFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'value': json['value'],
    'additionalData': json['additionalData'] === null || json['additionalData'] === undefined ? json['additionalData'] : ExpAdditionalDataFactory.FromJSON(json['additionalData'])
  };
});
_defineProperty(ExpListValueElementFactory, "ToJSON", function (value) {
  return _ExpListValueElementFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpListValueElementFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'value': value.value,
    'additionalData': ExpAdditionalDataFactory.ToJSON(value.additionalData)
  };
});
//# sourceMappingURL=ExpListValueElement.js.map
